import BuildControl from "../BuildControl";
import ProjectList from "./ProjectList";
import CreateNewProject from "./CreateNewProject";
import { useState } from "react";
import { useFirestore } from "react-redux-firebase";
import { ArrowLeft, Plus, Lock, LockOpen } from "phosphor-react";
import styled from "styled-components";
import { useProjects } from "../../../hooks/useContacts";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Holder = styled.div`
  width: 100%;
  @media screen and (min-width: 900px) {
    max-width: 1200px;
    padding: 0;
  }
  padding: 0 10px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`;

const Button = styled.button`
  margin: 0;
`;

const Locking = styled.div`
  margin: 0;
  background: ${({ edit }) => (edit ? "var(--primary)" : "transparent")};
  svg {
    color: ${({ edit }) => (edit ? "white" : "var(--primary)")};
  }
  border: 1px solid var(--primary);
  padding: 5px 10px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
`;

const ProjectControl = () => {
  const firestore = useFirestore();
  const [selectedProject, setSelectedProject] = useState(null);
  const [newProjectVisible, setProjectVisible] = useState(false);
  const [edit, setEdit] = useState(false);

  const { docs: projects } = useProjects();

  const handleClick = () => {
    if (selectedProject != null) {
      setSelectedProject(null);
    } else {
      setProjectVisible(!newProjectVisible);
    }
  };

  const handleAddingNewProjectToList = () => {
    setProjectVisible(!newProjectVisible);
  };

  const handleSelectingProject = (id) => {
    const project = projects.filter((project) => project.id === id);
    setSelectedProject(project[0]);
  };

  const handleDelete = (id) => {
    if (prompt("type DELETE to delete this project") === "DELETE") {
      alert("Deleted!");
      firestore.delete({ collection: "projects", doc: id });
      currentlyVisibleState = (
        <ProjectList
          projects={projects}
          handleClick={handleSelectingProject}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          edit={edit}
        />
      );
      buttonText = <Plus size={20} weight={"bold"} />;
    } else {
      alert("NOT deleted :)");
    }
  };

  const handleEdit = (id, key, value) => {
    return firestore.update(
      { collection: "projects", doc: id },
      {
        [key]: value,
      }
    );
  };

  let currentlyVisibleState = null;
  let buttonText = null;

  if (selectedProject != null) {
    currentlyVisibleState = (
      <BuildControl project={selectedProject} handleDelete={handleDelete} />
    );
    buttonText = <ArrowLeft size={20} weight={"fill"} />;
  } else if (newProjectVisible) {
    currentlyVisibleState = (
      <CreateNewProject onNewProjectCreation={handleAddingNewProjectToList} />
    );
    buttonText = <ArrowLeft size={20} weight={"fill"} />;
  } else {
    currentlyVisibleState = (
      <ProjectList
        projects={projects}
        handleClick={handleSelectingProject}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        edit={edit}
      />
    );
    buttonText = <Plus size={20} weight={"bold"} />;
  }
  return (
    <Container>
      <Holder>
        <Buttons>
          <Button onClick={handleClick}>{buttonText}</Button>

          <Locking edit={edit} onClick={() => setEdit(!edit)}>
            {!edit ? (
              <Lock size={20} weight={"fill"} />
            ) : (
              <LockOpen size={20} weight={"fill"} />
            )}
          </Locking>
        </Buttons>
        {currentlyVisibleState}
      </Holder>
    </Container>
  );
};

export default ProjectControl;
